import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-popup',
    templateUrl: './loading-popup.component.html',
    styleUrls: ['./loading-popup.component.scss'],
    standalone: false
})
export class LoadingPopupComponent implements OnInit {

  @Input()
  message: string;

  @Input()
  progress: number;

  constructor() { }

  ngOnInit(): void {
  }

}
